<template>
  <section class="py-32 md:py-56 lg:py-88">
    <suspense>
      <se-advisor-advisors-list :query="{ sort: 'rankings_desc' }" :has-paging="true">
        <template #title>
          <h1 class="text-h-l md:text-h-2xl font-semibold">
            Top {{ config.advisors }}
          </h1>
        </template>
      </se-advisor-advisors-list>
    </suspense>
  </section>
</template>

<script lang="ts" setup>
import {theme} from '@/theme';
import SeAdvisorAdvisorsList from '../components/advisors-list';

const config = theme.general;
</script>

<script lang="ts">
export default {
  name: 'SeAdvisorTopAdvisorsPage',
};
</script>
